'use es6';

import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { VISITOR } from 'conversations-message-history/constants/messageUses';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getMessage } from 'conversations-message-history/unpublished-messages/operators/getters';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import CommonMessageContent from '../common-message/CommonMessageContent';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ActivelyPublishingMessage extends PureComponent {
  render() {
    const {
      fileAttachments,
      message: activelyPublishingMessage,
      positionDescriptors
    } = this.props;
    const message = getMessage(activelyPublishingMessage);
    const isLast = positionDescriptors.includes(LAST);
    return /*#__PURE__*/_jsxs(PrimaryMessage, {
      use: VISITOR,
      "data-test-id": "primary-message",
      children: [/*#__PURE__*/_jsx(CommonMessageContent, {
        fileAttachments: fileAttachments,
        isLastMessage: isLast,
        message: message
      }), isLast && /*#__PURE__*/_jsx(PrimaryMessageFooter, {
        children: /*#__PURE__*/_jsx(VizExSmall, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "conversations-visitor-message-history.status.publishing.UNPUBLISHED"
          })
        })
      })]
    });
  }
}
ActivelyPublishingMessage.displayName = 'ActivelyPublishingMessage';
ActivelyPublishingMessage.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  message: RecordPropType('ActivelyPublishing').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default ActivelyPublishingMessage;